<div class="generic-cfl">

    <h2 mat-dialog-title class="dialog-title text-center fs-5">E-Way Bill</h2>

    <mat-dialog-content class="eWapPopupContent">
         <mat-button-toggle-group #group="matButtonToggleGroup" value="EWBDetails">
            <mat-button-toggle value="EWBDetails">EWB Details</mat-button-toggle>
            <mat-button-toggle value="TransportationDetails">Transportation Details</mat-button-toggle>
            <mat-button-toggle value="BillFrom">Bill From</mat-button-toggle>
            <mat-button-toggle value="BillTo">Bill To</mat-button-toggle>
            <mat-button-toggle value="DispatchFrom">Dispatch From</mat-button-toggle>
            <mat-button-toggle value="ShipTo">Ship To</mat-button-toggle>
        </mat-button-toggle-group>

        <ng-container *ngIf="group.value === 'EWBDetails'">
            <div class="row mt-2">
                <div class="col-md-6">
                    <h4 class="tab-heading">EWB Details</h4>
                </div>
            </div>
           <div class="row">
                <div class="col-md-4">
                    <label class="f-label">Supply Type*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select class="full-width"
                            [(ngModel)]="EwayBillDetails.SupplyType"
                            [readonly]="screenType == 1">
                            <mat-option *ngFor="let item of supplyType" [value]="item.value">
                                {{item.key}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Subtype*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select [(ngModel)]="EwayBillDetails.SubType"
                            [readonly]="screenType == 1">
                            <mat-option *ngFor="let item of subType" [value]="item.subID">
                                {{item.subType}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Document Type*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select class="full-width"
                            [(ngModel)]="EwayBillDetails.DocumentType"
                            [readonly]="screenType == 1">
                            <mat-option *ngFor="let item of docType" [value]="item.typeCode">
                                {{item.typeName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Transaction Type*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select [(ngModel)]="EwayBillDetails.TransactionType"
                            [readonly]="screenType == 1">
                            <mat-option *ngFor="let item of transactionType" [value]="item.value">
                                {{item.key}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Main HSN*</label>
                     <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                            [(ngModel)]="mainHsnEntry"
                            (click)="openDialog(hsnList, 'Main HSN')" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">E-Way Bill No.*</label>
                     <mat-form-field class="full-width" appearance="outline">
                         <input required type="text" matInput
                            [(ngModel)]="EwayBillDetails.EWayBillNo" 
                            [disabled]="!EwayBillDetails.EWayBillNo" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">E-Way Bill Date*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input [matDatepicker]="pickerone" type="text" matInput (click)="pickerone.open()"
                            [(ngModel)]="EwayBillDetails.EWayBillDate"
                            [disabled]="!EwayBillDetails.EWayBillNo" />
                        <mat-datepicker-toggle matSuffix [for]="pickerone">
                        </mat-datepicker-toggle>
                        <mat-datepicker #pickerone></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">EWB Expiration Date</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input [matDatepicker]="pickertwo" type="text" matInput
                            (click)="pickertwo.open()" disabled
                            [(ngModel)]="EwayBillDetails.EWayBillExpirationDate"
                            [disabled]="!EwayBillDetails.EWayBillNo" />
                        <mat-datepicker-toggle matSuffix [for]="pickertwo">
                        </mat-datepicker-toggle>
                        <mat-datepicker #pickertwo></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Cancellation Reason</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select
                            [(ngModel)]="EwayBillDetails.U_UTL_CARES" [disabled]="!EwayBillDetails.EWayBillNo">
                            <mat-option *ngFor="let item of canRemarks" [value]="item.code">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Cancel Remark</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput [(ngModel)]="EwayBillDetails.U_UTL_ST_CANRMK"
                        [disabled]="!EwayBillDetails.EWayBillNo" />
                    </mat-form-field>
                </div>
                {{docData.U_UTL_ST_UPRESR}}
                <div class="col-md-4">
                    <label class="f-label">Update Reason</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select [(ngModel)]="EwayBillDetails.U_UTL_ST_UPRESR" [disabled]="!EwayBillDetails.EWayBillNo">
                            <mat-option *ngFor="let item of updateReason" [value]="item.value">
                                {{item.key}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Update Remarks</label>
                    <mat-form-field class="full-width" appearance="outline">
                       <input required type="text" matInput [(ngModel)]="EwayBillDetails.U_UTL_ST_URMK" 
                       [disabled]="!EwayBillDetails.EWayBillNo" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Update Date</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input [matDatepicker]="pickersix" type="text" matInput
                            (click)="pickersix.open()" [(ngModel)]="EwayBillDetails.U_UTL_ST_EWayUpDt"
                            [disabled]="!EwayBillDetails.EWayBillNo" />
                        <mat-datepicker-toggle matSuffix [for]="pickersix">
                        </mat-datepicker-toggle>
                        <mat-datepicker #pickersix></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">EWay Bill Status</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.U_UTL_ST_EWBSts"
                        [disabled]="!EwayBillDetails.EWayBillNo"
                        matTooltip="{{docData.U_UTL_ST_EWBSts}}" matTooltipPosition="below" />
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="group.value === 'TransportationDetails'">
            <div class="row mt-2">
                <div class="col-md-6">
                    <h4 class="tab-heading">Transportation Details</h4>
                </div>
            </div>
           <div class="row">
                <div class="col-md-4">
                    <label class="f-label">Transporter Code*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput [(ngModel)]="transportCode"
                        (click)="openDialog(transportList, 'Transporter')">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Transporter Name*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput [(ngModel)]="EwayBillDetails.TransporterName">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Transporter ID*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput [(ngModel)]="EwayBillDetails.TransporterID">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Mode*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select required [(ngModel)]="EwayBillDetails.TransportationMode">
                            <mat-option *ngFor="let item of transMode" [value]="item.modeCode">
                                {{item.modeName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Vehicle Type*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-select [(ngModel)]="EwayBillDetails.VehicleType">
                           <mat-option *ngFor="let item of vehicleType" [value]="item.typeCode">
                                {{item.typeName}}
                           </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Vehicle No*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput 
                        [(ngModel)]="EwayBillDetails.VehicleNo">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Distance (in KM)*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput
                        [(ngModel)]="EwayBillDetails.Distance" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Transporter Doc No*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput
                        [(ngModel)]="EwayBillDetails.TransporterDocNo" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Transporter Doc Date*</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input matInput [matDatepicker]="picker4"
                        [(ngModel)]="EwayBillDetails.TransporterDocDate" />
                        <mat-datepicker-toggle matIconSuffix [for]="picker4">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker4></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="group.value === 'BillFrom'">
            <div class="row mt-2">
                <div class="col-md-6">
                    <h4 class="tab-heading">Bill From</h4>
                </div>
            </div>
           <div class="row">
                <div class="col-md-4">
                    <label class="f-label">Name</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput
                        [(ngModel)]="EwayBillDetails.BillFromName"
                        [disabled]="screenType == 1" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">GSTIN</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input type="text" matInput
                        [(ngModel)]="EwayBillDetails.BillFromGSTIN"
                        [disabled]="screenType == 1" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">State</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="billFromStateGSTCode" (click)="openDialog(stateList, 'BillFrom')"
                        />
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="group.value === 'BillTo'">
            <div class="row mt-2">
                <div class="col-md-6">
                    <h4 class="tab-heading">Bill To</h4>
                </div>
            </div>
           <div class="row">
                <div class="col-md-4">
                    <label class="f-label">Name</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.BillToName" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">GSTIN</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.BillToGSTIN" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">State</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="billToStateGSTCode"
                        (click)="openDialog(stateList, 'BillTo')" />
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="group.value === 'DispatchFrom'">
            <div class="row mt-2">
                <div class="col-md-6">
                    <h4 class="tab-heading">Dispatch From</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label class="f-label">Address 1</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.DispatchFromAddress1" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Address 2</label>
                    <mat-form-field class="full-width" appearance="outline">
                       <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.DispatchFromAddress2" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Place</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.DispatchFromPlace"/>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Zip Code</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.DispatchFromZipCode"/>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Actual State</label>
                    <mat-form-field class="full-width" appearance="outline">
                       <input required type="text" matInput
                        [(ngModel)]="dispatchFromStateGSTCode"
                        (click)="openDialog(stateList, 'DispatchFrom')" />
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="group.value === 'ShipTo'">
            <div class="row mt-2">
                <div class="col-md-6">
                    <h4 class="tab-heading">Ship To</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label class="f-label">Address 1</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.ShipToAddress1" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Address 2</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.ShipToAddress2"
                        [disabled]="screenType == 1" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Place</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.ShipToPlace" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Zip Code</label>
                    <mat-form-field class="full-width" appearance="outline">
                        <input required type="text" matInput
                        [(ngModel)]="EwayBillDetails.ShipToZipCode" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <label class="f-label">Actual State</label>
                    <mat-form-field class="full-width" appearance="outline">
                         <input required type="text" matInput
                        [(ngModel)]="shipToStateGSTCode"
                        (click)="openDialog(stateList, 'ShipTo')" />
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-raised-button color="primary" (click)="save()">Save</button>
        <button mat-stroked-button color="primary" [mat-dialog-close]="false">Cancel</button>
        <div *ngIf="screenType != 0 || objectType == '67'" class="eWayDropdown">
            <mat-form-field appearance="outline" class="mb-0">
                <mat-select placeholder="E-Way" [(ngModel)]="eWayBtn"
                    (selectionChange)="selectEWay(eWayBtn)">
                    <mat-option *ngFor="let item of eWayArr" [value]="item.value">
                        {{item.key}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </mat-dialog-actions>
</div>